import { type ChangeEvent } from 'react'
import * as S from './Checkbox.styles'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  testId?: string
}

function Checkbox({ checked, onChange, testId, ...otherProps }: CheckboxProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event.target.checked)
  }

  return (
    <S.Container>
      <S.Label>
        <S.Input
          {...otherProps}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          data-testid={testId}
        />
        <S.Span $checked={checked}>
          <svg width="10px" height="8px" viewBox="0 0 10 8">
            <path d="M1 4.42857L3.66667 7L9 1" />
          </svg>
        </S.Span>
      </S.Label>
    </S.Container>
  )
}

export default Checkbox
